import React from 'react';
import { Empty } from 'antd';
import type { DockingRecord } from '../../types/docking';
import type { MarketProject } from '../../types/market';
import { DockingRecordCard } from './DockingRecordCard';
import {
  ProjectContextLinks,
  type ProjectContextMode,
} from './ProjectContextLinks';

export interface DockingDetailPanelProps {
  selectedProjectId: string | null;
  projects: MarketProject[];
  records: DockingRecord[];
  progressCount?: number;
  incompleteProgressCount?: number;
  onNavigateRelated?: (mode: ProjectContextMode) => void;
}

export function DockingDetailPanel(
  props: DockingDetailPanelProps,
): React.ReactElement {
  const {
    selectedProjectId,
    projects,
    records,
    progressCount = 0,
    incompleteProgressCount = 0,
    onNavigateRelated,
  } = props;
  const projectName = selectedProjectId
    ? projects.find((p) => p.id === selectedProjectId)?.name
    : null;

  const links =
    selectedProjectId && onNavigateRelated ? (
      <ProjectContextLinks
        current="docking"
        dockingCount={records.length}
        progressCount={progressCount}
        incompleteProgressCount={incompleteProgressCount}
        onNavigate={onNavigateRelated}
      />
    ) : null;

  if (!selectedProjectId) {
    return (
      <aside className="dash-panel dash-panel--right">
        <div className="dash-detail-empty">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <span className="dash-empty-text">
                请在左侧选择项目查看对接记录
              </span>
            }
          />
        </div>
      </aside>
    );
  }

  if (records.length === 0) {
    return (
      <aside className="dash-panel dash-panel--right">
        <div className="dash-detail-title">
          {projectName ?? '项目'}的对接记录
        </div>
        {links}
        <div className="dash-detail-empty" style={{ flex: 1 }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <span className="dash-empty-text">该项目暂无对接记录</span>
            }
          />
        </div>
      </aside>
    );
  }

  return (
    <aside className="dash-panel dash-panel--right">
      <div className="dash-detail-title">
        {projectName ?? '项目'}的对接记录（{records.length} 条）
      </div>
      {links}
      <div className="docking-records-list">
        {records.map((record) => (
          <DockingRecordCard key={record.id} record={record} />
        ))}
      </div>
    </aside>
  );
}
